import { render, staticRenderFns } from "./news-add.vue?vue&type=template&id=d99a18ac&scoped=true&"
import script from "./news-add.vue?vue&type=script&lang=js&"
export * from "./news-add.vue?vue&type=script&lang=js&"
import style0 from "./news-add.vue?vue&type=style&index=0&id=d99a18ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d99a18ac",
  null
  
)

export default component.exports